import { createElementVNode as _createElementVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "toolbelt",
  class: "toolbelt"
}
const _hoisted_2 = { class: "tool-btn" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-grip-horizontal" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-mouse-pointer" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { style: {"white-space":"nowrap"} }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-crop-alt" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { style: {"white-space":"nowrap"} }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "tool-divider" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!
  const _component_ToolHelper = _resolveComponent("ToolHelper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startDrag && _ctx.startDrag(...args))),
        class: "tool-btn-icon grip"
      }, _hoisted_4, 32)
    ]),
    _createElementVNode("div", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTool = 'cursor')),
      class: _normalizeClass(["tool-btn", { active: _ctx.activeTool == 'cursor' }])
    }, [
      _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
        activator: _withCtx((on) => [
          _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "tool-btn-icon" }), _hoisted_6, 16)
        ]),
        tooltip: _withCtx(() => [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t(`ssa.visualizer.toolbelt.cursor`)), 1)
        ]),
        _: 1
      })
    ], 2),
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.activeTool = 'clipping')),
      class: _normalizeClass(["tool-btn", { active: _ctx.activeTool == 'clipping', disabled: !_ctx.canClip }])
    }, [
      _createVNode(_component_imdex_tooltip, { nudgeY: -10 }, {
        activator: _withCtx((on) => [
          _createElementVNode("div", _mergeProps(_toHandlers(on), { class: "tool-btn-icon" }), _hoisted_9, 16)
        ]),
        tooltip: _withCtx(() => [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t(`ssa.visualizer.toolbelt.clipping`)), 1)
        ]),
        _: 1
      })
    ], 2),
    _hoisted_11,
    _withDirectives(_createVNode(_component_ToolHelper, {
      onClearClip: _ctx.clearClip,
      active: !_ctx.draggingToolbelt && _ctx.activeTool == 'clipping'
    }, null, 8, ["onClearClip", "active"]), [
      [_vShow, !_ctx.draggingToolbelt && _ctx.activeTool == 'clipping']
    ])
  ], 512))
}